import { connect } from 'react-redux';
import { compose } from 'recompose';

import { wrapHoc } from 'modules/common/hocs/wrapHOC';
import { saveAvatar } from 'modules/user/actions/saveAvatar';
import { withAvatarUpload } from 'modules/user/hocs/avatarUpload';

import UserIcon from '../UserIcon';
import UserIconWithEdit from './UserIconWithEdit';

const mapStateToProps = (state) => ({
  avatar: state.auth.userInfo.profile.avatar,
});

const mapDispatchToProps = {
  saveAvatar,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),

  withAvatarUpload,

  wrapHoc(UserIconWithEdit),
)(UserIcon);
